import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import imgPizza from '../../img/Pizza2.png';
// import './styleMobile.css'; // Código legado - CardapioSalao desativado
import CryptoJS from 'crypto-js';
import { toast } from "react-toastify";
import { getAdicionaisCardapio, getItemCardapio, getEmpresaWithObjId } from "../../services/api";
import { MdFastfood } from "react-icons/md";
import SafeImage from '../../components/SafeImage';
import { formatPriceWithSymbol } from '../../utils/currency';

const DetalheProduto = () => {
    const { t } = useTranslation('cardapio');
    const navigate = useNavigate();
    // Obtém o external_id da URL atual, se existir
    const [searchParams] = useSearchParams();
    const externalId = searchParams.get('external_id');
    const secretKey = 'my-custom-secret-key:1af0addcce4b56f753ed10c285667ad031bae57af19747f576b05312b8cf85be';
    const location = useLocation();
    const [item, setItem] = useState(null);
    const [adicionais, setAdicionais] = useState([]);
    const { nomeEmpresaForUrl, idEmpresa, objIdProduto } = useParams();
    const [itensCarrinho, setItensCarrinho] = useState(() => {
        const itensFromStorage = Cookies.get('itensCarrinhoMobile');
        return itensFromStorage ? JSON.parse(itensFromStorage) : [];
    });
    const [empresaObjId, setEmpresaObjId] = useState(null);
    const [openStatus, setOpenStatus] = useState("");

    useEffect(() => {
        const fetchItem = async () => {
            try {
                const response = await getItemCardapio(idEmpresa, objIdProduto);
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('response>', response);
                if (response.data.item) {
                    setItem(response.data.item);
                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("JSON.stringify(response.data.item):",JSON.stringify(response.data.item))
                    setEmpresaObjId(response.data.item.empresaObjId);
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar item:', error);
            }
        };

        if (location.state?.item) {
            setItem(location.state?.item);
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("JSON.stringify(location.state?.item):",JSON.stringify(location.state?.item))
        } else {
            fetchItem();
        }
    }, [idEmpresa, location.state?.item, objIdProduto]); // Adicionadas dependências necessárias

    useEffect(() => {
        (async () => {

            try {

                if (empresaObjId) {
                    const empresaTemp = await getEmpresaWithObjId(empresaObjId);
                    if (empresaTemp) {
                        // Converte o objeto empresa para uma string JSON e criptografa para salvamento no sessionStorage
                        const empresaString = JSON.stringify(empresaTemp.data.empresa);
                        const encryptedEmpresa = CryptoJS.AES.encrypt(empresaString, secretKey).toString();

                        if (empresaTemp.data.empresa.status_loja === "sempre") {                 
                            setOpenStatus("Sempre aberto");
                        }
                        if (empresaTemp.data.empresa.status_loja === "especifico" && !empresaTemp.data.empresa.horario_funcionamento) {
                            //setHorariosFuncionamento("Sem horário de funcionamento definido");
                            //setCurrentTime("Sem horário de funcionamento definido");
                        }
                        if (empresaTemp.data.empresa.status_loja === "especifico" && empresaTemp.data.empresa.horario_funcionamento) {
                            //setHorariosFuncionamento(empresaTemp.data.empresa.horario_funcionamento);
                        }
                        if (!empresaTemp.data.empresa.status_loja) {
                            if (openStatus === "" || openStatus === "Fechado") {
                                toast(t('store.closed'), { autoClose: false, type: 'error', position: 'bottom-center' });
                                setOpenStatus("Fechado");
                            }
                        }
                        // Armazena a string JSON no sessionStorage
                        sessionStorage.setItem("sessionCompany", encryptedEmpresa);
                        //setLoadingData(false);  // Set loading to false after all states are updated
                    }
                    else {
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Nenhuma categoria encontrada!");
                        //setLoadingData(false);  // Set loading to false if no data is found
                    }
                }

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // Tratar o erro 404 Not Found
                    //setErrorMessage("Erro 404: Página não encontrada");
                    //setShowError(true);
                } else {
                    // Tratar outros erros
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Unexpected error:", error);
                    //setErrorMessage("Ocorreu um erro inesperado");
                    //setShowError(true);
                }
                //setLoadingData(false);  // Set loading to false on error
            }
        })();
    }, [empresaObjId, openStatus]); // Adicionada dependência 'openStatus'

    useEffect(() => {
        const fetchAdicionais = async () => {
            try {
                const response = await getAdicionaisCardapio(idEmpresa, nomeEmpresaForUrl);
                const adicionaisFromDB = response.data.adicionais;
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("item::", item)
                if (item?.adicionais && adicionaisFromDB) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("CHEGOU AQUI?")
                    const adicionaisEncontrados = adicionaisFromDB.filter(adicionalDB =>
                        item?.adicionais.some(adicionalItem => adicionalItem.value === adicionalDB._id)
                    );
                    // Tipo A: ordenar os grupos pela ordem definida no item (drag-and-drop)
                    const __ordemGrupos = (item?.adicionais || []).map(a => String(a.value));
                    adicionaisEncontrados.sort((a, b) => __ordemGrupos.indexOf(String(a._id)) - __ordemGrupos.indexOf(String(b._id)));
                    setAdicionais(adicionaisEncontrados.map(adicional => ({
                        ...adicional,
                        quantidade: adicional.mandatory ? Math.max(1, adicional.min) : adicional.min || 0
                    })));
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar adicionais:', error);
            }
        };

        if (item) {
            fetchAdicionais();
        }
    }, [idEmpresa, nomeEmpresaForUrl, item]);

    useEffect(() => {
        const itensWithoutImages = itensCarrinho.map(item => {
            const { price_salao, ...itemWithoutImages } = item;
            const decryptedPrice = CryptoJS.AES.decrypt(price_salao, secretKey).toString(CryptoJS.enc.Utf8);
            const totalValue = item?.quantity * parseFloat(decryptedPrice);
            const encryptedTotalValue = CryptoJS.AES.encrypt(totalValue.toString(), secretKey).toString();
            return { ...itemWithoutImages, price_salao, totalValue: encryptedTotalValue };
        });
        // Salvar os itens no cookie com expiração de 1 hora, substituindo localxStorage
        Cookies.set('itensCarrinhoMobile', JSON.stringify(itensWithoutImages), { expires: 1 / 24 });  // 1/24 de um dia = 1 hora
    }, [itensCarrinho]);

    useEffect(() => {
        const itensFromStorage = Cookies.get('itensCarrinhoMobile');
        if (itensFromStorage) {
            setItensCarrinho(JSON.parse(itensFromStorage));
        }
    }, []);

    const handleBack = () => {
        if (externalId) {
            // Se external_id existir, inclui ele na navegação
            navigate(`/cardapio-salao/${nomeEmpresaForUrl}/${idEmpresa}?external_id=${externalId}`);
        } else {
            // Caso contrário, navega sem external_id
            navigate(`/cardapio-salao/${nomeEmpresaForUrl}/${idEmpresa}`);
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    return (
        <div className="flex flex-col max-w-sm mx-auto bg-white rounded-lg shadow-md overflow-hidden md:max-w-2xl">
            <div className="backButtonDetalhe" onClick={handleBack}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={28}
                    height={28}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-left"
                >
                    <polyline points="15 18 9 12 15 6" />
                </svg>
            </div>
            <div className="compartilharButtonDetalhe">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22.75"
                    height="22.75"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#3E3E3E"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-share-2"
                >
                    <circle cx={18} cy={5} r={3} />
                    <circle cx={6} cy={12} r={3} />
                    <circle cx={18} cy={19} r={3} />
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                </svg>
            </div>
            <div className="flex-shrink-0">
                <SafeImage
                    className="h-56 w-full object-cover"
                    width={390}
                    height={370}
                    src={item?.image}
                    alt="product"
                    fallback={
                        item?.type === "pizza"
                            ? <img className="h-56 w-full object-cover" width={390} height={370} src={imgPizza} alt="product" />
                            : <div><MdFastfood style={{ fontSize: 390 }} /></div>
                    }
                />
            </div>
            <div className="p-4">
                <h3 className="text-lg font-semibold">{item?.title}</h3>
                <p className="text-gray-700" style={{ color: "#1095F3", fontWeight: 600 }}>{formatPriceWithSymbol(item?.price_salao || 0)}</p>
                <p className="mt-2 text-xs text-gray-500" dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br/>') }}></p>
            </div>
            {process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ADICIONAIS:::", JSON.stringify(adicionais))}
            {adicionais && adicionais.length > 0 &&
                adicionais.sort((a, b) => {
                    // Ordena colocando os do tipo "pizza" no início
                    if (a.type === 'pizza' && b.type !== 'pizza') return -1;
                    if (a.type !== 'pizza' && b.type === 'pizza') return 1;
                    return 0; // Mantém a ordem original para os que têm o mesmo tipo
                }).map((adicionalPai, i) => (
                    <div key={i}>
                        {adicionalPai.adicionais && adicionalPai.adicionais.length > 0 && (
                            <div className="observacoesDetalhe">
                                <div className="obsTextBox" style={{ width: '100%' }}>
                                    <div className="adicionalTitleText">
                                        <div className="childrenDivTitleAdicionalCardapio">
                                            <span>{adicionalPai.title}</span>                             
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {adicionalPai.adicionais && adicionalPai.adicionais.length > 0 && adicionalPai.adicionais.map((adicional, index) => {
                            if (!adicional.out_salao) {
                                return (
                                    <div key={index} className="containerPaiAdicionais">
                                        <div className={`divContendoAdicionais ${index === 0 ? 'first' : ''}`}>
                                            <div style={{ width: '70%', display: 'flex', flexDirection: 'row', gap: 7 }}>
                                                <SafeImage
                                                    src={adicional.image}
                                                    alt="img"
                                                    className="imgAdicional"
                                                    fallback={
                                                        adicionalPai?.type === "pizza"
                                                            ? <img className="h-56 w-full object-cover" width={50} height={50} src={imgPizza} alt="product" />
                                                            : <div><MdFastfood style={{ fontSize: 50 }} /></div>
                                                    }
                                                />
                                                <div>
                                                    <label htmlFor={`adicional_${adicional._id}`} className="text-adicional-item">
                                                        {adicional.title}
                                                    </label>
                                                    <div style={{ color: "#1095F3", fontWeight: 500 }}>{formatPriceWithSymbol(adicional.price_salao || 0)}</div>
                                                </div>
                                            </div>
                                          
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                ))}        
        </div>
    );
};

export default DetalheProduto;
